import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/dist/query/react";
import {getAuthToken} from "../store/reducers/AuthSlice";
import {Tags} from "./Tags";
import {getBaseUrl} from "./ApiUrls";
import {IStatisticModel, IStatisticModelRunReq, IStatisticModelRunResult, IStatisticModelTransactionsReq, IStatisticModelTransactionsResult, IStatisticModelWrite} from "../model/IStats";

export const statisticModelApi = createApi({
    reducerPath: 'statisticModelApi',
    tagTypes: [Tags.StatisticModel],
    baseQuery: fetchBaseQuery({
        baseUrl: getBaseUrl() + '/api/v1/transactions/stats/models/',
        prepareHeaders: (headers) => {
            const token = getAuthToken();
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        }
    }),
    endpoints: (build) => ({
        fetchAllStatisticModels: build.query<IStatisticModel[], void>({
            query: () => ({
                url: '/',
            }),
            providesTags: [Tags.StatisticModel],
        }),
        fetchStatisticModel: build.query<IStatisticModel, number>({
            query: (id) => ({
                url: `/${id}/`,
            }),
            providesTags: (_result, _error, id) => [{type: Tags.StatisticModel, id}],
        }),
        createStatisticModel: build.mutation<IStatisticModel, IStatisticModelWrite>({
            query: (body) => ({
                url: '/',
                method: 'POST',
                body,
            }),
            invalidatesTags: [Tags.StatisticModel],
        }),
        updateStatisticModel: build.mutation<IStatisticModel, {id: number, body: IStatisticModelWrite}>({
            query: ({id, body}) => ({
                url: `/${id}/`,
                method: 'PATCH',
                body,
            }),
            invalidatesTags: [Tags.StatisticModel],
        }),
        deleteStatisticModel: build.mutation<void, number>({
            query: (id) => ({
                url: `/${id}/`,
                method: 'DELETE',
            }),
            invalidatesTags: [Tags.StatisticModel],
        }),
        runStatisticModel: build.mutation<IStatisticModelRunResult, {id: number, body: IStatisticModelRunReq}>({
            query: ({id, body}) => ({
                url: `/${id}/run/`,
                method: 'POST',
                body,
            }),
        }),
        fetchStatisticModelTransactions: build.mutation<IStatisticModelTransactionsResult, {id: number, body: IStatisticModelTransactionsReq}>({
            query: ({id, body}) => ({
                url: `/${id}/transactions/`,
                method: 'POST',
                body,
            }),
        }),
    }),
});
